<template>
  <div>
    <el-container>
      <el-main v-loading="loading">

        <el-row type="flex">
          <el-col :xs="1" :sm="6" :lg="6">
            <div class="bg-2">&nbsp;</div>
          </el-col>
          <el-col :xs="23" :lg="12">
            <div class="y-title bg-1">{{ $t("packageVue.onlineCredit") }}</div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="6" :lg="6">
            <div class="bg-2">&nbsp;</div>
          </el-col>
          <el-col :xs="23" :lg="12">
            <div class="Yipps ">{{ $t("packageVue.onlineCreditDis1") }}<span class="text-style-1">{{ $t("packageVue.onlineCreditDisc2") }}</span></div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="6" :lg="6">
            <div class="bg-2">&nbsp;</div>
          </el-col>
          <el-col :xs="23" :lg="12"><div class="y-title bg-1">{{ $t("packageVue.package") }}</div></el-col>
        </el-row>

        <el-row v-for="(yipPackage, key) in yipPackages" :key="yipPackage.id" type="flex" align="middle">

          <el-col :xs="1" :sm="13" :lg="6">
            <div class="bg-1">&nbsp;</div>
          </el-col>

          <el-col class="radioContainer">
            <div class="bg-2">
              <el-radio v-model="yipRadio" :label="key">&nbsp;

              </el-radio>
            </div>
          </el-col>

          <el-col :xs="16" :lg="8">
            <div class="bg-1 content-2" @click="updateRadio(key)">
              <img src="@/assets/welcome/ic-16-yipps@2x.png">
              &nbsp;&nbsp;
              <span class="price-style-1">{{ yipPackage.yipps_point }}&nbsp;&nbsp;Yipps</span>
            </div>
          </el-col>

          <el-col :xs="2" :lg="8">
            <div class="bg-2 curr-1" @click="updateRadio(key)">{{ yipPackage.currency }}&nbsp;&nbsp;<span class="price-style-1">{{ yipPackage.value }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="5" :lg="6">
            <div class="bg-1">&nbsp;</div>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="11"><el-divider /></el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="1" :sm="13" :lg="6">
            <div class="bg-1">&nbsp;</div>
          </el-col>
          <el-col class="radioContainer" />
          <el-col :xs="16" :lg="8"><div class=" bg-2">{{ $t("packageVue.pay") }}</div></el-col>
          <el-col :xs="2" :lg="8"><div v-if="yipPackages[yipRadio]" class="  curr-1">{{ yipPackages[yipRadio].currency }}&nbsp;&nbsp;<span class="price-style-1">{{ yipPackages[yipRadio].value }}</span></div></el-col>
        </el-row>

        <el-row type="flex">
          <el-col :xs="14" :lg="13"><div class="" /></el-col>
          <el-col :xs="11" :lg="2"><div class=""><el-button :disabled="submitIsDisabled" @click="submit">{{ $t("packageVue.payButton") }}</el-button></div></el-col>

        </el-row>
      </el-main>

    </el-container>

    <form ref="form" style="display: hidden" :action="env" method="POST">
      <template v-for="(value, key) in requestParam">
        <input :id="key" :key="key" type="hidden" :name="key" :value="value">
      </template>

    </form>
  </div>
</template>

<script>
import axiosWallet from '../../axios-wallet'
import { mapGetters } from 'vuex'
export default {
  filters: {
    mathTrunc: function(value) {
      if (!value) return ''
      return Math.trunc(value)
    }
  },
  data() {
    return {
      env: process.env.VUE_APP_PAYMENT_GATEWAY_URL,
      yipRadio: 0,
      requestParam: null,
      loading: true,
      submitIsDisabled: false
    }
  },
  computed: {
    ...mapGetters({
      yipPackages: 'packageStore/getYipPackages'
    })
  },
  created() {
    if (this.$store.getters['packageStore/getYipPackages'][0]) {
      this.loading = false
    } else {
      this.$store.watch(
        (state, getters) => getters['packageStore/getYipPackages'],
        (newValue, oldValue) => {
          if (typeof (newValue) === 'object') {
            this.loading = false
          }
        },
      )
    }
  },
  methods: {
    updateRadio(value) {
      this.yipRadio = value
    },
    submit() {
      this.submitIsDisabled = true
      if (!this.$store.getters['authStore/isAuthenticated']) {
        this.$store.dispatch('authStore/logout')
        this.$router.push('/login')
        return true
      }

      axiosWallet.post('/api/iap/aeropay/get-trxrefno', {
        package_id: this.$store.getters['packageStore/getYipPackages'][this.yipRadio].id
      })
        .then((response) => {
          this.requestParam = response.data.body
          this.$store.commit('packageStore/SET_CHOSEN_PACKAGE', {
            ...this.$store.getters['packageStore/getYipPackages'][this.yipRadio],
            transactionRefId: response.data.body.orderDescription
          })

          // waiting hidden form generation
          setTimeout(() => {
            // testing response page without going through payment gateway
            // this.$router.push('/response')
            this.$refs.form.submit()
          }, 2000)
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

  .div-class{

    height: 540px;
    background-size:100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .y-title {
    height: 28px;
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }

  .Yipps {
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  height: 100%;
}

.Yipps .text-style-1 {
  font-weight: 600;
  color: #d0021b;
}

.curr-1 {
  width: 57px;
  height: 29px;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #9b9b9b;
}

.el-button  {
  width: 175px;
  height: 42px;
  border-radius: 4px;
  background-color: #f5c923;
}
.el-button:hover,
.el-button:active {
  background-color: #00AEEF;
  color: white;
}

/* .bg-1{
  background-color: burlywood;
}
.bg-2{
  background-color: palegreen;
} */

.price-style-1 {
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.content-2{
  text-align: center;
  display: flex;
  align-items: center;
}

.radioContainer{
  width: 20px;
}
</style>
